export default __webpack_public_path__ + "static/media/ScreenShot 1.025ddf41.png";